import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPeopleTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m21 7.83-4.06 4.786-1.624-1.436M13.42 7.83c0 2.114-1.697 3.829-3.79 3.829s-3.789-1.715-3.789-3.83S7.54 4 9.632 4s3.79 1.714 3.79 3.83m-3.79 6.7C6.056 14.53 3 15.076 3 17.257S6.036 20 9.632 20c3.577 0 6.631-.545 6.631-2.725s-3.035-2.744-6.631-2.744"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPeopleTick;
